module.exports = __webpack_public_path__ + "img/arrow_left_2.13391b70.svg";